import { CONNECTIONS } from './types';
const initialState = {
    availableCommercialAPIPartners: [],
};
export const connectionsReducer = (state = initialState, action) => {
    switch (action.type) {
        case CONNECTIONS:
            return {
                ...state,
                ...action.connections,
            };
        default:
            return state;
    }
};
